// extracted by mini-css-extract-plugin
export default {"root":"DescriptionButton-root","isCollapsed":"DescriptionButton-isCollapsed"};